import React from "react";
import styled from "styled-components";
import { breakpointSize } from "../../../theme/mediaQuerie";
import ExitModalIcon from "../Icons/ExitModalIcon";
import Typography from "../typography/Typography";

interface IModal {
  handleShow: React.Dispatch<React.SetStateAction<boolean>>;
  show: boolean;
  title: string;
  description?: string;
  children: any;
}

const ModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  background-color: rgba(8, 8, 17, 0.8);


`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  gap: 32px;
  width: fit-content;
  min-height: 333px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  position: relative;
  text-align: center;

  @media screen and (max-width: 780px) {
    height: auto;
    max-height: 500px;
    overflow: scroll;
    display: block;
  }

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    padding: 32px;
  }
`;

const isMobile = window.innerWidth <= breakpointSize.Sm;

const Modal: React.FC<IModal> = ({
  handleShow,
  show,
  title,
  description,
  children,
}) => {
  if (!show) return <></>;

  return (
    <ModalWrapper>
      <ModalContainer>
        <ExitModalIcon
          onClick={() => handleShow(false)}
          style={{ position: 'absolute', top: '16px', right: '16px', cursor: 'pointer' }}
        />
        <Typography type={isMobile ? "headingM" : "headingXXL"} color="title">{title}</Typography>
        {description && <Typography type="paragraphS" color="title">{description}</Typography>}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          {children}
        </div>
      </ModalContainer>
    </ModalWrapper>
  );
};

export default Modal;
